/*
@license
  Expanse by Archetype Themes (https://archetypethemes.co)
  Access unminified JS in assets/theme.js

  Use this event listener to run your own JS outside of this file.
  Documentation - https://archetypethemes.co/blogs/expanse/javascript-events-for-developers

  document.addEventListener('page:loaded', function() {
    // Page has loaded and theme assets are ready
  });
*/

if (console && console.log) {
  console.log(
    "Expanse theme (" +
      theme.settings.themeVersion +
      ") by ARCHΞTYPE | Learn more at https://archetypethemes.co"
  );
}

(function () {
  "use strict";

  if (
    window.Shopify &&
    window.Shopify.theme &&
    navigator &&
    navigator.sendBeacon &&
    window.Shopify.designMode
  ) {
    navigator.sendBeacon(
      "https://api.archetypethemes.co/api/beacon",
      new URLSearchParams({
        shop: window.Shopify.shop,
        themeName:
          window.theme &&
          window.theme.settings &&
          `${window.theme.settings.themeName} v${window.theme.settings.themeVersion}`,
        role: window.Shopify.theme.role,
        route: window.location.pathname,
        themeId: window.Shopify.theme.id,
        themeStoreId: window.Shopify.theme.theme_store_id || 0,
        isThemeEditor: !!window.Shopify.designMode,
      })
    );
  }

  /*============================================================================
    Things that don't require DOM to be ready
  ==============================================================================*/

  /*============================================================================
    Things that require DOM to be ready
  ==============================================================================*/
  function DOMready(callback) {
    if (document.readyState != "loading") callback();
    else document.addEventListener("DOMContentLoaded", callback);
  }

  DOMready(function () {
    document.dispatchEvent(new CustomEvent("page:loaded"));
  });
})();

/* Reflexions 9.1 remaining fixes — 2026-07-25 */
(function () {
  "use strict";

  if (window.__rxRemainingFixes20260725) return;
  window.__rxRemainingFixes20260725 = true;

  if (!document.getElementById("rx-remaining-fixes-20260725")) {
    var style = document.createElement("style");
    style.id = "rx-remaining-fixes-20260725";
    style.textContent =
      "@media (max-width:520px){" +
      ".rxCartOverlay.is-active .rxCartPanel{padding-bottom:0!important;}" +
      ".rxCartDrawer{height:100%!important;max-height:100%!important;min-height:0!important;overflow:hidden!important;}" +
      ".rxCartDrawer__scroll{flex:1 1 auto!important;min-height:0!important;overflow-y:auto!important;padding-bottom:24px!important;}" +
      ".rxReviewBar,.rxCheckoutBar{transform:none!important;margin-bottom:0!important;position:relative!important;flex:0 0 auto!important;padding-bottom:calc(16px + env(safe-area-inset-bottom))!important;}" +
      "}";
    document.head.appendChild(style);
  }

  var concernLinks = {
    "/collections/gloss-absolu": "/collections/hair-concern-shine",
    "/collections/frizzy-hair": "/collections/hair-concern-frizz-control",
    "/collections/damaged-hair": "/collections/hair-concern-repair",
    "/collections/colour-care": "/collections/hair-concern-color-protection",
    "/collections/curly-hair": "/collections/hair-concern-curls",
    "/collections/thinning-hair": "/collections/hair-concern-thinning"
  };

  function fixConcernLinks(root) {
    var links = (root || document).querySelectorAll("a[href]");
    links.forEach(function (link) {
      try {
        var url = new URL(link.getAttribute("href"), window.location.origin);
        var replacement = concernLinks[url.pathname.replace(/\/$/, "")];
        if (replacement) {
          link.setAttribute("href", replacement + url.search + url.hash);
        }
      } catch (error) {
        // Ignore invalid or non-standard links.
      }
    });
  }

  function applyFixes() {
    fixConcernLinks(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", applyFixes, { once: true });
  } else {
    applyFixes();
  }

  var scheduled = false;
  new MutationObserver(function () {
    if (scheduled) return;
    scheduled = true;
    window.requestAnimationFrame(function () {
      scheduled = false;
      fixConcernLinks(document);
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
